import type { User } from '#auth-utils';
import type { InjectionKey } from 'vue';
import type { HeaderProps } from '~/components/PortalHeader';
import type { PropertyFilters } from '~/core/entities/property/filters';
import type { RegionService } from '~~/core/ports/services/RegionService';
import type { Condominium } from '~/core/entities/condo/Condo';

// diferente do provider do vue que podem se sobrescrever em lowerlevel, o provider do nuxt é um singleton e não permite esse problema acontecer. Por isso, ele só aceita string como chave.
export const PORTAL_API_CLIENT = 'portalAPIClient';

export const REGION_SERVICE: InjectionKey<RegionService> =
	Symbol('regionService');

export const USER_SYMBOL: InjectionKey<Ref<User | null>> = Symbol('user');
export const USER_OPTION_SYMBOL: InjectionKey<Ref<string | undefined>> =
	Symbol('userOption');

export const HERO_LAYOUT: InjectionKey<{
	headerVariant: Ref<HeaderProps['variant']>;
}> = Symbol('heroLayout');
export const PROPERTIES_LISTING_METHODS: InjectionKey<{
	updateMapFilters: (filters: PropertyFilters) => void;
}> = Symbol('propertiesListing');

export const CONDO_DETAILS: InjectionKey<Ref<Condominium | null>> =
	Symbol('condo');
